import type { Money } from "@/shared/value-objects/money.vo";
import type { Row } from "@tanstack/react-table";

export function monetaryDescNullsLastSortingFn<RowType>(
  rowA: Row<RowType>,
  rowB: Row<RowType>,
  columnId: string,
) {
  const a = rowA.getValue<Money | null>(columnId);
  const b = rowB.getValue<Money | null>(columnId);

  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return b.amount - a.amount;
}
